// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-background.crash-game-wrapper .how-to-play-modal .modal-dialog {
  max-width: 900px;
}
.game-background.crash-game-wrapper .how-to-play-modal .modal-dialog .modal-body {
  padding: 0 3.75rem 0 3.75rem;
  position: relative;
}
.game-background.crash-game-wrapper .how-to-play-modal .modal-dialog .modal-body:after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 20%;
  background: var(--sliderOverlayGradient180deg);
  pointer-events: none;
  border-radius: 0 0 0.8rem 0.8rem;
}
.game-background.crash-game-wrapper .how-to-play-modal .modal-dialog .modal-body .how-to-play-title h5 {
  font-size: 2rem;
  font-weight: 600;
  margin-top: 3.125rem;
}
.game-background.crash-game-wrapper .how-to-play-modal .modal-dialog .modal-body .how-to-play-title p {
  margin-bottom: 2.5rem;
}
.game-background.crash-game-wrapper .how-to-play-modal .modal-dialog .modal-body .how-to-play-content-body {
  min-height: 100px;
  overflow: auto;
  height: calc(100vh - 400px);
}
@media only screen and (max-width: 768px) {
  .game-background.crash-game-wrapper .how-to-play-modal .modal-dialog .modal-body .how-to-play-content-body {
    height: calc(100vh - 200px);
  }
}
.game-background.crash-game-wrapper .how-to-play-modal .modal-dialog .modal-body .how-to-play-content-body::-webkit-scrollbar {
  width: 0;
}
.game-background.crash-game-wrapper .how-to-play-modal .modal-dialog .modal-body .how-to-play-content-body .game-content-box .game-content-items {
  border-radius: 0.938rem;
  background-color: var(--gameContentBg);
  padding: 1.5rem;
  font-weight: normal;
}
.game-background.crash-game-wrapper .how-to-play-modal .modal-dialog .modal-body .how-to-play-content-body .game-content-box .game-content-items:not(:last-child) {
  margin-bottom: 1rem;
}
.game-background.crash-game-wrapper .how-to-play-modal .modal-dialog .modal-body .how-to-play-content-body .game-content-box .game-content-items ul {
  margin: 0;
}
.game-background.crash-game-wrapper .how-to-play-modal .modal-dialog .modal-body .how-to-play-content-body .game-content-box .game-content-items ul li:not(:last-child) {
  margin-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/games/CrashGames/GameTheme/FlyCrashGame/components/HowToPlay/HowToPlay.scss"],"names":[],"mappings":"AAIM;EACE,gBAAA;AAHR;AAKQ;EACE,4BAAA;EACA,kBAAA;AAHV;AAKU;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,8CAAA;EACA,oBAAA;EACA,gCAAA;AAHZ;AAOY;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AALd;AAQY;EACE,qBAAA;AANd;AAUU;EACE,iBAAA;EACA,cAAA;EACA,2BAAA;AARZ;AASY;EAJF;IAKI,2BAAA;EANZ;AACF;AAQY;EACE,QAAA;AANd;AAUc;EACE,uBAAA;EACA,sCAAA;EACA,eAAA;EACA,mBAAA;AARhB;AASgB;EACE,mBAAA;AAPlB;AASgB;EACE,SAAA;AAPlB;AASoB;EACE,mBAAA;AAPtB","sourcesContent":["\n.game-background {\n  &.crash-game-wrapper {\n    .how-to-play-modal {\n      .modal-dialog {\n        max-width: 900px;\n\n        .modal-body {\n          padding: 0 3.75rem 0 3.75rem;\n          position: relative;\n\n          &:after {\n            content: '';\n            position: absolute;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            height: 20%;\n            background: var(--sliderOverlayGradient180deg);\n            pointer-events: none;\n            border-radius: 0 0 0.8rem 0.8rem;\n          }\n\n          .how-to-play-title {\n            h5 {\n              font-size: 2rem;\n              font-weight: 600;\n              margin-top: 3.125rem;\n            }\n\n            p {\n              margin-bottom: 2.5rem;\n            }\n          }\n\n          .how-to-play-content-body {\n            min-height: 100px;\n            overflow: auto;\n            height: calc(100vh - 400px);\n            @media only screen and (max-width: 768px) {\n              height: calc(100vh - 200px);\n            }\n\n            &::-webkit-scrollbar {\n              width: 0;\n            }\n\n            .game-content-box {\n              .game-content-items {\n                border-radius: 0.938rem;\n                background-color: var(--gameContentBg);\n                padding: 1.5rem;\n                font-weight: normal;\n                &:not(:last-child) {\n                  margin-bottom: 1rem;\n                }\n                ul {\n                  margin: 0;\n                  li {\n                    &:not(:last-child) {\n                      margin-bottom: 1rem;\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
